import { StyleSheet, View } from 'react-native'
import { Text } from 'react-native-paper'
import type { Location } from '@/types/locations'
import { ConditionalList } from '@/ui/ConditionalList'
import { LocationCard } from './LocationCard'

interface LocationsListProps {
    locations: Location[]
    isLoading: boolean
}

export function LocationsList({ locations, isLoading }: LocationsListProps) {
    return (
        <ConditionalList
            data={locations}
            isLoading={isLoading}
            icon="map-marker"
            title="No locations yet"
            subtitle="Create your first location to define geographical areas for your organization."
        >
            <View style={styles.container}>
                <View style={styles.header}>
                    <Text variant="bodyMedium" style={styles.count}>
                        {locations.length} location{locations.length !== 1 ? 's' : ''}
                    </Text>
                </View>

                <View style={styles.list}>
                    {locations.map(location => (
                        <LocationCard key={location.id} location={location} />
                    ))}
                </View>
            </View>
        </ConditionalList>
    )
}

const styles = StyleSheet.create({
    container: {
        gap: 12,
    },
    header: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    count: {
        color: '#666',
    },
    list: {
        gap: 12,
    },
})
